export default __webpack_public_path__ + "static/media/icon-kb-dark.f2146f77.svg";